import React from 'react';
import { FEATURE_TESTIMONIALS as MOCK_FT, TESTIMONIALS as MOCK_T } from '../mock';
import { useI18n } from '../i18n/I18nProvider';
import { useBookersContent } from '../hooks/useBookersContent';

export function Results({ cms }) {
  const { t } = useI18n();
  const { results: fallbackResults } = useBookersContent();
  const r = cms || {};
  const eyebrow = r.eyebrow || t('results.eyebrow');
  const title = r.title || t('results.title');
  const description = r.description || t('results.description');
  const items = r.items || fallbackResults;

  return (
    <section className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
      <div className="text-center max-w-2xl mx-auto reveal">
        <p className="text-sm font-semibold text-[#76B828]">{eyebrow}</p>
        <h2 className="font-display text-4xl md:text-5xl mt-3 text-[#0b0b0f]">{title}</h2>
        <p className="text-[#55555f] mt-4 text-lg">{description}</p>
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
        {items.map((item, i) => (
          <div key={i} className="reveal text-center" style={{ transitionDelay: `${i * 80}ms` }}>
            <p className="font-display text-5xl md:text-6xl text-[#0b0b0f]">{item.value}<span className="text-[#76B828]">{item.suffix}</span></p>
            <p className="text-[#6b6b73] mt-3 text-[15px] max-w-[200px] mx-auto">{item.note}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export function Testimonials({ cms }) {
  const { t } = useI18n();
  const data = cms || {};
  const featureTestimonials = data.feature_testimonials || MOCK_FT;
  const shortTestimonials = data.short_testimonials || MOCK_T;

  return (
    <section className="bg-[#fafafb] border-y border-black/5">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 section-pad">
        <div className="max-w-2xl reveal">
          <p className="text-sm font-semibold text-[#76B828]">{t('testimonials.eyebrow')}</p>
          <h2 className="font-display text-4xl md:text-5xl mt-3 text-[#0b0b0f]">{t('testimonials.title')}</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 mt-12">
          {featureTestimonials.map((ft, i) => (
            <figure key={ft.name} className="reveal relative rounded-3xl overflow-hidden border border-black/5 group" style={{ transitionDelay: `${i * 90}ms` }}>
              <img src={ft.image} alt={ft.name} className="w-full h-[420px] object-cover group-hover:scale-105 transition-transform duration-700" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
              <figcaption className="absolute inset-x-0 bottom-0 p-6 text-white">
                <p className="text-[15px] leading-relaxed">{`"${ft.quote}"`}</p>
                <p className="font-display text-lg mt-4">{ft.name}</p>
                <p className="text-white/70 text-sm">{ft.role}, {ft.company}</p>
              </figcaption>
            </figure>
          ))}
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 mt-6">
          {shortTestimonials.map((st, i) => (
            <div key={st.name} className="reveal bg-white rounded-2xl border border-black/5 p-6" style={{ transitionDelay: `${(i % 4) * 70}ms` }}>
              <p className="font-semibold text-[#0b0b0f]">{st.title}</p>
              <p className="text-[#6b6b73] mt-2 text-sm leading-relaxed">{st.quote}</p>
              <div className="mt-4 pt-4 border-t border-black/5">
                <p className="text-sm font-semibold text-[#0b0b0f]">{st.name}</p>
                <p className="text-xs text-[#8b8b95]">{st.role}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
